export enum UnderwritingType {
    DELEGATED = 'DELEGATED',
    NON_DELEGATED = 'NON_DELEGATED'
}

export const underwritingTypeDisplay = {
    [UnderwritingType.DELEGATED]: 'Delegated',
    [UnderwritingType.NON_DELEGATED]: 'Non-delegated'
};
